<template>
    <div >
        <v-row class="mb-3 py-2" no-gutters>
        <v-col cols="10" sm="6" class="d-flex justify-start mb-2">
            <v-text-field   
                      density="compact"  
                      variant="outlined"       
                      v-model.number="coef" 
                      type="number"
                      :max="1.5"
                      :min="0"
                      :step="0.01"
                      :label="$t('demanda.coeficiente')"
                     style="min-width: 100px; max-width: 250px; "
                     @input="onInput"
                     v-if="!vista_operador"
                    >
                      
                </v-text-field>
                <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
            </v-col>
        </v-row>
        <div class="contenedor-tabla">
        <div class="scroll-container">
           <!-- {{ this.horizonte_horas }}-->
            <table>
               <!--  <caption class="table-header">Senda de {{ this.$t('tabs.demanda_vapor') }}</caption> -->
                <thead>
                <tr>
                    <th class="encabezado_bold" >{{ this.$t('demanda.horizonte') }}</th>
                    <th class="encabezado_bold" >{{ this.$t('demanda.hora') }}</th>
                    <th class="encabezado_bold" >{{ this.$t('demanda.vapor') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="( row,index) in demandaVapor.slice(0,this.horizonte_horas)" :key="index" class="tabla-hover">
                    <td class="primera_columna">{{row.horizonte}}</td>
                    <td class="primera_columna" style="text-align: center !important;">{{ row.hora }}</td>
                    <td>
                        <input
                    type="number"
                    v-model.number="row.valor"
                    @input="emitChanges()"
                    
                />
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
      </div>
        <v-dialog v-model="showAlert" max-width="400">
                <v-card>
                    <v-card-title class="headline">{{$t('simulaciones.advertencia')}}</v-card-title>
                    <v-card-text>
                    {{ error_msg }}
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showAlert = false">{{$t('simulaciones.cerrar')}}</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>
    </div>

           

</template>


<script>
import Papa from 'papaparse';
import Swal from 'sweetalert2';
const REQ_PROV = ['Date', 'Prediccion', 'Version'];
const REQ_APP  = ['Horizonte', 'Hora', 'Demanda de vapor (MW)'];
//imports
export default{
   props:{
    demanda_vapor:{
        type:Array,
        required:true,
    },
    demanda_coef:{
        type:Number,
        required:true,
    },
    horizonte:{
        type:Number,
        required:true,
    },
    fechaActual:{
        type: Date,
        required:true,
    },
    horizonte_horas:{
        type:Number,
        required:true,
    },
    vista_operador: {
    type: Boolean,
    default: false
  },
   },
   components:{
      

   },
   data(){
       return{

            showAlert:false,
            matrixData : [
                   
               ],
           hoursList:[],
           demandaVapor : 
                    [...this.demanda_vapor]
                   ,
                   coef:this.demanda_coef,
               columns:[
               { name: "Horizonte", prop: "Horizonte", size: 150, readonly:true },
               {name: this.$t("demanda.vapor"), prop:"demanda_vapor",size:200},
               
                   ],
       }
   },
   created(){
       //this.crearColumnas(7);
   },
   watch:{

    demanda_coef:{
        handler(newDatos){
            this.coef=newDatos;
        },
        deep:true,
        immediate: true,
    },
    demanda_vapor: {
        handler(nuevaDemanda) {
            console.log("Demanda de vapor actualizada en el hijo:", nuevaDemanda);
            this.demandaVapor = [...nuevaDemanda]; // Forzar actualización
        },
        deep: true
    },

   },

   methods:{
    toCsvDecimalComma(v, fixed = 2) {
        if (v === null || v === undefined || v === '') return '';
        let n = Number(v);
        if (Number.isNaN(n)) n = Number(String(v).replace(',', '.')); 
        if (Number.isNaN(n)) return '';
        return n.toLocaleString('es-ES', {
            minimumFractionDigits: fixed,
            maximumFractionDigits: fixed,
            useGrouping: false, 
        });
        },
    emitChanges(){
        //console.log("cambiosn: ");
        //console.log(this.matrixData[index].precioMercado);

        //const valores=this.precioMercado;
        this.$emit("update:demanda_vapor", this.demandaVapor);  
    },
    onInput(){
        if(this.coef >1.5){
            this.coef =1.5;
        } else if (this.coef <0){
            this.coef=0;
        }
        this.$emit('update:demanda_coef',this.coef);
    },
   exportToCSV() {
    const headers = 'Horizonte;Hora;Demanda de vapor (MW)';

    const rows = this.demandaVapor
        .slice(0, this.horizonte_horas)
        .map(row => {
        const horizonte = row.horizonte ?? '';
        const hora = row.hora ?? '';
        const valor = this.toCsvDecimalComma(row.valor, 2); // <-- coma decimal
        return [horizonte, hora, valor].join(';');
        });

    const csvContent = [headers, ...rows].join('\n');
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'demanda_vapor.csv';
    a.click();
    URL.revokeObjectURL(url);
    },
       crearColumnas(dias){
            const currentDate = new Date();

            // Sumar un día a la fecha actual
            currentDate.setDate(currentDate.getDate() + 1);
            
            // Generar la columna con las horas
             this.hoursList = [];
            for (let day=0; day<dias;day++){
                const newDate = new Date(currentDate);
                newDate.setDate(currentDate.getDate() + day);
                const formattedDate = newDate.toLocaleDateString('en-GB').replace(/\//g, '-'); // Formato 28-01-25
        
                for (let i = 0; i < 24; i++) {
                    const hour = i.toString().padStart(2, '0'); // Asegura que la hora tenga 2 dígitos
                    this.hoursList.push(`${formattedDate} ${hour}:00`);
                    this.matrixData.push({
                        horizonte:`${formattedDate} ${hour}:00`,
                        
                        demanda_vapor:this.demandaVapor[i+(day*24)],
                    })
                }
            }
            //console.log(hoursList);
       },

        convertirFecha(fechaString) {
          let [fecha,hora]=fechaString.split(' ');
          //Por problemas de leer de csv, a veces la fecha
          let dia;
          let mes;
          let anio;
          if (fecha.includes('/')) {
            // Si la fecha tiene '/' como separador
             [dia, mes, anio] = fecha.split('/');
            } else if (fecha.includes('-')) {
                // Si la fecha tiene '-' como separador
             [anio, mes, dia] = fecha.split('-');
            }
          let [horaStr,minutoStr] = hora.split(':')
          horaStr = horaStr.padStart(2,'0');
          //console.log("Fecha: ", `${anio}-${mes}-${dia} ${horaStr}:${minutoStr}`)
          horaStr = horaStr.padStart(2,'0'); //Rellenar los dígitos individuales en 2
          const fechaItem = `${anio}-${mes}-${dia} ${horaStr}:${minutoStr}`
          return fechaItem;
        },

          //Llamada a input de CSV
          importFromCSV() {
          this.$refs.fileInput.click();
        },
        //Para buscar valores por las fechas correctas y de la versión correcta
        filtrarYOrdenarDatosPorFechaYVersion(datos, fechaBuscar) {
                // Convertir las fechas de entrada a objetos Date para comparaciones
                //const fechaInicioDate = new Date(fechaInicio.split('/').reverse().join('-'));
                //const fechaFinDate = new Date(fechaFin.split('/').reverse().join('-'));
                
                // Filtrar los datos por el rango de fechas
                const datosFiltrados = datos.filter(item => {
                   let [fecha,hora]=item.Date.split(' ');
                   const delim =fecha.split('/').length > fecha.split('-').length ? '/' : '-';
                    
                   let partes = fecha.split(delim);
                   let anioAlPrincipio = partes[0].length === 4;

                    let dia, mes, anio;
                    if (anioAlPrincipio) {
                        [anio, mes, dia] = partes;
                    } else {
                        [dia, mes, anio] = partes;
                    }
                    let [horaStr,minutoStr] = hora.split(':')
                    horaStr = horaStr.padStart(2,'0'); //Rellenar los dígitos individuales en 2
                    const fechaItem = `${anio}-${mes}-${dia} ${horaStr}:${minutoStr}`;
                    //const fechaItem =  new Date(Date.UTC(anio, mes , dia, horaStr, minutoStr))
                    
                    //console.log("fecha item:  ---- ", fechaItem , " a buscar: ", fechaBuscar )
                    
                    return fechaItem == fechaBuscar ;
                });
                //console.log("Datos filtrados: ", datosFiltrados)
                //console.log("fechas:", fechaInicio.getTimezoneOffset() ,"  -  ", fechaFin.getTimezoneOffset())
                if (datosFiltrados.length === 0) {
                    this.error(3);
                    return [];  // Si no hay datos en el rango de fechas
                }

                // Encontrar la última versión dentro de los datos filtrados
                const ultimaVersion = datosFiltrados.reduce((ultimo, actual) => {
                    const versionUltimo = parseInt(ultimo.Version.substring(1), 10);  // Convierte V1 -> 1
                    const versionActual = parseInt(actual.Version.substring(1), 10);  // Convierte V2 -> 2
                    return versionActual > versionUltimo ? actual : ultimo;
                }).Version;  
                const datosUltimaVersion = datosFiltrados.filter(item => item.Version === ultimaVersion);
                // Ordenar los datos de la última versión por fecha, de menor a mayor
                const datosOrdenados = datosUltimaVersion.sort((a, b) => {
                    const fechaA = new Date(a.Date.split('/').reverse().join('-'));
                    const fechaB = new Date(b.Date.split('/').reverse().join('-'));
                    return fechaA - fechaB;  // Ordenar de menor a mayor
                });
                
                return datosOrdenados;
                },
        parseNumber(value) {
            if (!value) return 0;
            value = value.trim();

            if (value.includes(',') && !value.includes('.')) {
                value = value.replace(/\./g, '');        
                value = value.replace(',', '.');          
            }

            else if (value.includes(',') && value.includes('.')) {
                
                if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
                value = value.replace(/\./g, '');       
                value = value.replace(',', '.');      
                }
                
                else {
                value = value.replace(/,/g, '');        
                }
            }
            return parseFloat(value);
            },

  //Gestión de subida de archivos CSV
  handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({icon:'error', title:'Formato no válido', text:'Solo se admiten archivos .csv.'});
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    const data = e.target.result;
    const delim = this.guess_delimiter ? this.guess_delimiter(data.split('\n')[0]) : ';';

    Papa.parse(data, {
      delimiter: delim,
      skipEmptyLines: true,
      header: true,
      complete: (result) => {
        let rows = result.data || [];
        // elimina filas completamente vacías
        rows = rows.filter(r => Object.values(r).some(v => String(v ?? '').trim() !== ''));
        if (!rows.length) {
          Swal.fire({icon:'error', title:'CSV vacío', text:'El archivo no contiene datos.'});
          event.target.value = '';
          return;
        }

        // ===== Cabeceras detectadas
        let headers = result.meta?.fields ? [...result.meta.fields] : Object.keys(rows[0] || {});
        if (headers[0]) headers[0] = String(headers[0]).replace(/^\uFEFF/, ''); 
        headers = headers.map(h => String(h).trim());
        //  ignorar columnas "temperatura" y "componente"
        headers = headers.filter(h => !['temperature', 'componente'].includes(h.toLowerCase()));

        // ===== validación de cabeceras 
        const validarCabeceras = (detected, EXPECTED, checkOrder = true) => {
        const faltantes = EXPECTED.filter(h => !detected.includes(h));
        const extras = detected
          .filter(h => !EXPECTED.includes(h))
          .map(x => String(x).trim())
          .filter(Boolean);

        const desordenadas = [];
        if (checkOrder) {
          EXPECTED.forEach((h, i) => {
            if (detected[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
          });
        }

        return { faltantes, extras, desordenadas, ok: !(faltantes.length || extras.length || desordenadas.length) };
      };

        const prov = validarCabeceras(headers, REQ_PROV, false); // ignora orden para proveedor
        const app  = validarCabeceras(headers, REQ_APP, true);   // mantiene orden para plantilla interna

        // ========== Formato viscosim
        if (prov.ok) {
          const faltantesPorCol = { Date: [], Prediccion: [], Version: [] };
          const negativos = [];

          rows.forEach((r, idx) => {
            const line = idx + 2; 
            const d = String(r.Date ?? '').trim();
            const pRaw = r.Prediccion;
            const v = String(r.Version ?? '').trim();

            if (!d) faltantesPorCol.Date.push(line);

            if (pRaw === undefined || pRaw === null || String(pRaw).trim() === '') {
              faltantesPorCol.Prediccion.push(line);
            } else {
              const num = this.parseNumber(String(pRaw));
              if (!Number.isFinite(num)) faltantesPorCol.Prediccion.push(line);
              else if (num < 0) negativos.push(line); // NEGATIVOS NO PERMITIDOS 
            }

            if (!v) faltantesPorCol.Version.push(line);
          });

          if (negativos.length) {
            Swal.fire({
              icon:'error',
              title:'Valores negativos no permitidos',
              html:`Se han encontrado valores negativos en
               <b>Prediccion</b> (líneas: <b>${negativos.slice(0,10).join(', ')}${negativos.length>10?'…':''}</b>).`
            });
            event.target.value = '';
            return;
          }

          const columnasConFaltas = Object.entries(faltantesPorCol).filter(([, arr]) => arr.length);
          if (columnasConFaltas.length) {
            const html = columnasConFaltas.map(([col, arr]) =>
              `• <b>${col}</b>: líneas <b>${arr.slice(0,10).join(', ')}${arr.length>10?'…':''}</b>`
            ).join('<br>');
            Swal.fire({icon:'error', title:'Faltan datos obligatorios', html});
            event.target.value = '';
            return;
          }

          // Mapear a demandaVapor 
          const next = this.demandaVapor.slice(0, this.horizonte_horas).map(fila => {
            const cand = this.filtrarYOrdenarDatosPorFechaYVersion(rows, fila.horizonte);
            if (!cand.length) return null;
            const num = this.parseNumber(String(cand[0].Prediccion));
            return Number.isFinite(num) && num >= 0 ? { ...fila, valor: num } : null;
          });

          const faltantesHoriz = next.reduce((acc, r, i) => (r ? acc : acc.concat(this.demandaVapor[i].horizonte)), []);
          if (faltantesHoriz.length) {
            Swal.fire({
              icon:'error',
              title:'Horizontes sin datos',
              html:`No hay predicción válida para:<br><b>${faltantesHoriz.slice(0,8).join('</b>, <b>')}${faltantesHoriz.length>8?'…':''}</b>`
            });
            event.target.value = '';
            return;
          }

          const tail = this.demandaVapor.slice(this.horizonte_horas);
          this.demandaVapor = [...next, ...tail];
          this.$emit('update:demanda_vapor', [...this.demandaVapor]);
          Swal.fire({icon:'success', title:'Importación correcta', text:`${rows.length} filas leídas (formato proveedor).`});
          event.target.value = '';
          return;
        }

        // ========== Plantilla interna
        if (app.ok) {
          /*if (rows.length !== this.horizonte_horas) {
            Swal.fire({
              icon:'error',
              title:'Número de filas incorrecto',
              html:`Se esperaban ${this.horizonte_horas} filas y se recibieron <b>${rows.length}</b>.`
            });
            event.target.value = '';
            return;
          }*/

          const faltasPorCol = { 'Horizonte': [], 'Hora': [], 'Demanda de vapor (MW)': [] };
          const negativos = [];
          const nuevos = [...this.demandaVapor];

          rows.forEach((row, idx) => {
            const line = idx + 2;
            const hRaw = String(row['Horizonte'] ?? '').trim();
            const horaRaw = String(row['Hora'] ?? '').trim();
            const valRaw = row['Demanda de vapor (MW)'];

            if (!hRaw)  faltasPorCol['Horizonte'].push(line);
            if (!horaRaw) faltasPorCol['Hora'].push(line);

            if (valRaw === undefined || valRaw === null || String(valRaw).trim() === '') {
              faltasPorCol['Demanda de vapor (MW)'].push(line);
            } else {
              const v = this.parseNumber(String(valRaw));
              if (!Number.isFinite(v)) faltasPorCol['Demanda de vapor (MW)'].push(line);
              else if (v < 0) negativos.push(line); // NEGATIVOS NO PERMITIDOS 
            }
          });

          if (negativos.length) {
            Swal.fire({
              icon:'error',
              title:'Valores negativos no permitidos',
              html:`Se han encontrado valores negativos en <b>Demanda de vapor (MW)</b> (líneas: <b>${negativos.slice(0,10).join(', ')}${negativos.length>10?'…':''}</b>).`
            });
            event.target.value = '';
            return;
          }

          const columnasConFaltas = Object.entries(faltasPorCol).filter(([, arr]) => arr.length);
          if (columnasConFaltas.length) {
            const html = columnasConFaltas.map(([col, arr]) =>
              `• <b>${col}</b>: líneas <b>${arr.slice(0,10).join(', ')}${arr.length>10?'…':''}</b>`
            ).join('<br>');
            Swal.fire({icon:'error', title:'Faltan datos obligatorios', html});
            event.target.value = '';
            return;
          }

          // Actualizar por 'Horizonte'
          rows.forEach((row) => {
            const horizonteCsv = this.convertirFecha(String(row['Horizonte']).trim());
            const v = this.parseNumber(String(row['Demanda de vapor (MW)']));
            const i = nuevos.findIndex(it => it.horizonte === horizonteCsv);
            if (i !== -1) nuevos[i] = { ...nuevos[i], valor: v };
          });

          this.demandaVapor = nuevos;
          this.$emit('update:demanda_vapor', [...this.demandaVapor]);
          Swal.fire({icon:'success', title:'Importación correcta', text:`${rows.length} registros actualizados (plantilla interna).`});
          event.target.value = '';
          return;
        }

        // ========== Ninguna plantilla válida
        const seccion = (titulo, diag, esperado) => {
          const { faltantes, extras, desordenadas } = diag;
          const parts = [];
          if (faltantes.length)    parts.push(`❌ Faltan: <b>${faltantes.join(', ')}</b>`);
          if (extras.length)       parts.push(`⚠️ Sobran: <b>${extras.join(', ')}</b>`);
          if (desordenadas.length) parts.push(`🔄 Desordenadas: <b>${desordenadas.join(', ')}</b>`);
          return `<h4 style="margin:10px 0 4px 0;">${titulo}</h4>
                  <div>${parts.length ? parts.join('<br>') : '—'}</div>
                  <div style="margin-top:4px"><small>Orden esperado: ${esperado.join(' | ')}</small></div>`;
        };

        const html =
          `<div style="text-align:left;">
             <p>El CSV no coincide con ninguna plantilla conocida.</p>
             ${seccion('Formato proveedor (Date, Prediccion, Version)', prov, REQ_PROV)}
             ${seccion('Plantilla interna (Horizonte, Hora, Demanda de vapor (MW))', app, REQ_APP)}
           </div>`;

        Swal.fire({icon:'error', title:'Encabezados incorrectos', html, width: 820});
        event.target.value = '';
      },
      error: () => {
        Swal.fire({icon:'error', title:'Error', text:'No se pudo leer el CSV.'});
        event.target.value = '';
      }
    });
  };

  reader.readAsText(file, 'utf-8');
},

       error(n_error,extra=""){
        switch(n_error){
            case 1:
                this.error_msg="El csv debe contener las cabeceras de 'Date', 'Prediccion' y 'Version', u 'Horizonte' y 'Demanda de vapor (MW)'";
                break;
                case 2:
            this.error_msg="El coeficiente defe ser numérico";
                break;
                case 3:
                this.error_msg="No existe el horizonte: " +extra;
                break;
                case 4:
                   console.log("Caso 4");
                  break;
                case 5:
                  console.log("Caso 5");
                  break;
                case 6:
                  console.log("Caso 6");
                  break;
                case 7:
                  console.log("Caso 7");
                  break;
                case 8:
                  console.log("Caso 8");
                  break;
                case 9:
                  console.log("Caso 9");
                  break;
                case 10:
                  console.log("Caso 10");
                  break;
             
        }
        this.showAlert=true

       },
       guess_delimiter(headers) {
      return headers.split(',').length > headers.split(';').length ? ',' : ';';
    },
   },
}

</script>
<style scoped>
.contenedor-tabla {
  max-width: 600px;
  /* margin: auto; */
}
.scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); 
  overflow-x: auto;
  overflow-y: auto;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
  thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }
  .table-header {
    position: sticky;
    top: 0;
    z-index: 15;
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
    padding: 10px;
  }
  

  .primera_columna{
    background-color: white;
  }
  .valor_fijo{
    background-color: white;
  }
 /*  td {
    font-weight: bold;
    color: #024e74;
    border: 2px solid #D9D9D9;
    padding: 10px;
    background-color: #F2F2F2;
  } */
  input[type="number"] {
    width: 100%;
    text-align: center;
    border: none;
    border-radius: 4px;
    color: #024e74;
  }
  
  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #024e74;
  }
  .encabezado_bold {
    font-size:14px;
}

  



</style>